// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--1Or4Q","auto-prolong":"dd31006766--auto-prolong--w9cjI","hint":"dd31006766--hint--HChsp"};